import { API_URL } from "../../constants";
import * as httpNetworking from "../../httpNetworking";

const URL = API_URL + "/auth/signin";
const VERSION = 0;

export type AuthSignInResponse = {
    numberOfTriesLeft: number;
    otpCorrect: boolean;
};

export async function signInWithOTP(loginFlowId: string, otp: string): Promise<AuthSignInResponse> {
    let options: httpNetworking.POSTRequestConfig = {
        timeout: 10000
    };

    let params = {
        loginFlowId,
        otp
    };

    let response = (await httpNetworking.simplePOSTRequest(URL, params, options, VERSION)).data;
    return response;
}
